import { useEffect, useState } from 'react'

export type ScrollDirection = 'up' | 'down' | 'top'

export function useScrollDirection() {
  const [scrollDirection, setScrollDirection] = useState<ScrollDirection>('top')
  const [lastScrollY, setLastScrollY] = useState(0)

  useEffect(() => {
    let ticking = false

    const updateScrollDirection = () => {
      const scrollY = window.scrollY

      // At the very top of the page
      if (scrollY < 10) {
        setScrollDirection('top')
      }
      // Scrolling down
      else if (scrollY > lastScrollY && scrollY > 100) {
        setScrollDirection('down')
      }
      // Scrolling up
      else if (scrollY < lastScrollY) {
        setScrollDirection('up')
      }

      setLastScrollY(scrollY)
      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(updateScrollDirection)
        ticking = true
      }
    }

    window.addEventListener('scroll', onScroll)

    return () => window.removeEventListener('scroll', onScroll)
  }, [lastScrollY])

  return scrollDirection
}
